"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const common_1 = require("@Const/common");
const RecordingDataSection = (props) => {
    const { recordingData } = props;
    const { isrc, recordingTitle, recordingDisplayArtistName, duration, label } = recordingData;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "section-header" },
            react_1.default.createElement("img", { src: common_1.ICONS.recordingData, alt: 'Recording Data' }),
            react_1.default.createElement("h5", null, "Recording Data")),
        react_1.default.createElement("div", { className: 'details recording-details' },
            react_1.default.createElement("div", { className: 'horizontal-detail-pair' },
                react_1.default.createElement("p", { className: "label" }, "ISRC:"),
                react_1.default.createElement("p", { className: "semi-bold" }, isrc || 'N/A')),
            react_1.default.createElement("div", { className: 'horizontal-detail-pair' },
                react_1.default.createElement("p", { className: "label" }, "Recording Title:"),
                react_1.default.createElement("p", { className: "semi-bold" }, recordingTitle || 'N/A')),
            react_1.default.createElement("div", { className: 'horizontal-detail-pair' },
                react_1.default.createElement("p", { className: "label" }, "Recording Artist:"),
                react_1.default.createElement("p", { className: "semi-bold" }, recordingDisplayArtistName.join(', ') || 'N/A')),
            react_1.default.createElement("div", { className: 'horizontal-detail-pair' },
                react_1.default.createElement("p", { className: "label" }, "Duration:"),
                react_1.default.createElement("p", { className: "semi-bold" }, `${Math.floor(duration / 60)}m : ${duration % 60 > 10 ? duration % 60 : '0' + (duration % 60)}s`)),
            react_1.default.createElement("div", { className: 'horizontal-detail-pair' },
                react_1.default.createElement("p", { className: "label" }, "Label Name:"),
                react_1.default.createElement("p", { className: "semi-bold" }, label || 'NA')))));
};
exports.default = RecordingDataSection;
